import { useEffect, useState } from 'react';
import { getCurrentUser, logout, redirectToLogin } from '../../services/auth';
import { getUserById } from '../../services/identity';
import { useLanguage } from '../../context/LanguageContext';

const ProfilePage = () => {
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
  });
  const [status, setStatus] = useState(null);
  const { t } = useLanguage();

  const updateField = (field, value) => {
    setForm((previous) => ({ ...previous, [field]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setStatus(t('profile.saved'));
    setTimeout(() => setStatus(null), 2500);
  };

  useEffect(() => {
    let cancelled = false;
    const loadProfile = async () => {
      const user = getCurrentUser();
      if (!user) {
        redirectToLogin();
        return;
      }
      if (!cancelled) {
        setForm({
          name: user.name || '',
          phone: user.phone || '',
          email: user.email || '',
        });
      }

      let storedMeta = null;
      if (typeof window !== 'undefined') {
        try {
          storedMeta = JSON.parse(window.localStorage.getItem('myUser'));
        } catch {
          storedMeta = null;
        }
      }
      const userId = storedMeta?.customer_id || user.id;
      if (!userId) return;

      try {
        const response = await getUserById(userId);
        const data = response?.data?.data || response?.data || response;
        if (!cancelled && data) {
          setForm({
            name: data.firstName || data.name || user.name || '',
            phone: data.phoneNumber || user.phone || '',
            email: data.email || user.email || '',
          });
        }
      } catch (error) {
        if (error.status === 401 || error.status === 403) {
          // Session from before the security update, or expired: log in again
          logout();
          redirectToLogin('/profile');
          return;
        }
        if (!cancelled) {
          setStatus(
            error.message || t('profile.fetch_error')
          );
        }
      }
    };

    loadProfile();
    return () => {
      cancelled = true;
    };
  }, [t]);

  return (
    <div className="profile">
      <section className="profile-card">
        <h1>{t('profile.title')}</h1>
        <form className="profile-form" onSubmit={handleSubmit}>
          <label>
            <span>{t('profile.name_label')}</span>
            <input
              type="text"
              placeholder={t('profile.name_placeholder')}
              value={form.name}
              onChange={(event) => updateField('name', event.target.value)}
            />
          </label>
          <label>
            <span>{t('profile.phone_label')}</span>
            <input
              type="tel"
              placeholder={t('profile.phone_placeholder')}
              value={form.phone}
              onChange={(event) => updateField('phone', event.target.value)}
            />
          </label>
          <label>
            <span>{t('profile.email_label')}</span>
            <input
              type="email"
              placeholder={t('profile.email_placeholder')}
              value={form.email}
              onChange={(event) => updateField('email', event.target.value)}
            />
          </label>

          {status && <p className="profile-form__status">{status}</p>}

          <button type="submit" className="button profile-form__cta">
            {t('profile.save_button')}
          </button>
        </form>
      </section>
    </div>
  );
};

export default ProfilePage;
